import { defaultDoctor, Doctor } from '../../model/Doctor';
import { defaultPatient, Patient } from '../../model/Patient';
import { FormInfo } from '../../model/FormInfo';
import { Clinic } from '../../model/Clinic';
import { UploadedFile } from '../../model/UploadedFile';
import { Urgency } from '../../model/enums/Urgency';

export interface RegistrationState {
  formInfo?: FormInfo,
  clinic?: Clinic,
  goal: string,
  urgency: Urgency,
  description: string,
  diagnoses: string[],
  customDiagnosis: string,
  doctor: Doctor,
  patient: Patient,
  uploads: UploadedFile[]

  [key: string]: unknown
}

export const initialRegistrationState: RegistrationState = {
  goal: '',
  urgency: Urgency.Normal,
  description: '',
  diagnoses: [],
  uploads: [],
  customDiagnosis: '',
  doctor: defaultDoctor,
  patient: defaultPatient
};
